export const areLabelsExist = <T extends object>(
  objectToCheck: T | null,
  labelsArray: (keyof T)[] | null,
) => {
  if (objectToCheck && labelsArray && labelsArray?.length > 0) {
    return Object.keys(objectToCheck)?.some((key) => {
      return labelsArray.includes(key as keyof T);
    });
  } else {
    return false;
  }
};
